module.exports = __webpack_public_path__ + "static/media/фффффффф-removebg-preview.f37ce6f7.png";